import { List, Map } from 'immutable';

import { DEFAULT_COVERAGE_SORT } from '../../../constants';

export const createCoverageReducers = ({
  types,
  CoverageRecord,
}) => {
  const initialState = Map({
    loading: false,
    loadingCSV: false,
    coverage: List(),
    maxCount: 0,
    sort: Map(DEFAULT_COVERAGE_SORT),
  });

  const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case types.INITIALIZED:
      case types.GET_COVERAGE.REQUEST:
        return state.set('loading', true);
      case types.GET_COVERAGE.SUCCESS:
        return state.withMutations((newState) => {
          const coverage = payload.coverage.map((deviceInfo) => (
            new CoverageRecord(deviceInfo)
          ));
          newState
            .set('coverage', List(coverage))
            .set('maxCount', payload.max_count)
            .set('loading', false);
        });
      case types.GET_COVERAGE.FAILURE:
        return state.withMutations((newState) => {
          newState
            .set('loading', false)
            .set('maxCount', initialState.get('maxCount'))
            .set('coverage', initialState.get('coverage'));
        });
      case types.CHANGE_SORTING:
        return state.withMutations((newState) => {
          newState
            .setIn(['sort', 'direction'], payload.direction)
            .setIn(['sort', 'field'], payload.field);
        });
      case types.GET_COVERAGE_CSV.REQUEST:
        return state.set('loadingCSV', true);
      case types.GET_COVERAGE_CSV.SUCCESS:
      case types.GET_COVERAGE_CSV.FAILURE:
        return state.set('loadingCSV', false);
      case types.CLEANUP:
        return initialState;
      default:
        return state;
    }
  };

  return { initialState, reducer };
};
